import { BaseApiTemplateService } from "../shared/base-api-template-service.model";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Core2Config } from "../shared/core2Config";
import { ApiResponseModel,  Pagination, PagingResponseModel } from "../shared";
import { ApiVisa } from "../shared";
import { FilesDetailsRequest } from '../../../../../models/file-image';
import { Optional } from 'typescript-optional';
import {Observable} from 'rxjs';

@Injectable({ providedIn: "root" })
export class WarehouseGrnAttachmentService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/warehouse-grns/attachments";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "warehouses/warehouse-grns/attachments";
    this.httpClient = http;
  }

  public addAttachment(hdrGuid: string, files: File[], visa: ApiVisa,
    filesDetails?: FilesDetailsRequest) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach(file => formData.append('files', file));
    if (filesDetails) {
      formData.set(
        'files-data',
        new Blob([JSON.stringify(filesDetails)], { type: 'application/json' }),
        'files-data.json')
    }

    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl + '/add-files/backoffice-ep/' + hdrGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public updateAttachment(attachmentGuid: string, file: File, visa: ApiVisa,
    filesDetails: Optional<FilesDetailsRequest>): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    if (file) {
      formData.append('file', file);
      filesDetails.ifPresent(details =>
        formData.set(
          'file-data',
          new Blob([JSON.stringify(details)], { type: 'application/json' }),
          'file-data.json'));
    }

    return this.httpClient.put<ApiResponseModel<any>>(
        this.apiUrl + '/replace-file/backoffice-ep/' + attachmentGuid,
        formData,
        this.getHttpHeader(visa)
      );
    }

    public getAttachmentByCriteria(
      pagination: Pagination,
      visa: ApiVisa,
      criteria?: any,
    ): Observable<PagingResponseModel<any>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      const UrlByCriteria =
        this.apiUrl + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
      return this.httpClient.get<PagingResponseModel<any>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      );
    }

    public deleteAttachment(attachmentGuid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      return this.httpClient.delete<ApiResponseModel<any>>(
        this.apiUrl + '/backoffice-ep/' + attachmentGuid,
        this.getHttpHeader(visa)
      );
    }
  
    public getAttachmentFile(attachmentGuid: string, apiVisa: ApiVisa): Observable<Blob> {
      if (this.endpoint_path && apiVisa.api_domain_url) {
        this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
      }
      return this.httpClient.get<Blob>(
        this.apiUrl + '/file/backoffice-ep/' + attachmentGuid,
        this.getHttpHeaderBlob(apiVisa)
      );
    }

    public getAllAttachments(visa: ApiVisa): Observable<ApiResponseModel<any>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
      return this.httpClient.get<ApiResponseModel<any>>(
        this.apiUrl + '/backoffice-ep',
        this.getHttpHeader(visa)
      );
    }


}
